import { useMutation, useQueryClient } from 'react-query';
import { axiosInstance } from '../../libs/axiosConfig';
import type { ApiResponse } from '../types/Response';
import type { AxiosHeaderValue, ResponseType } from 'axios';

export const mutate = <T, Y = T>(
	path: string,
	body?: T,
	contentType: AxiosHeaderValue = 'application/json',
	responseType: ResponseType = 'json',
) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationKey: [path, body],
		mutationFn: async () => {
			return await axiosInstance
				.post(path, body, {
					responseType: responseType,
					headers: {
						'Content-Type': contentType,
					},
				})
				.then((res) => res.data as ApiResponse<Y>);
		},
		onSuccess: () => {
			queryClient.invalidateQueries();
		},
	});
};


